import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'

class EntityDetailPopUp extends Component {
    constructor(props){
        super()
        this.state = {

        }
    }
    
    
    render(){
        const {
            nif, 
            nome, 
            moradaFiscal, 
            codigoPostalFiscal1,
            codigoPostalFiscal2,
            localFiscal,
            codDis,
            codCon,
            codFrg
        } = this.props.response
        return(
            <div className="modal-content">
               <div className="modal-header info-wirad d-flex justify-content-between flex-wrap">
                  <h4 className="modal-title pl-0">Dados da Entidade</h4>
                  <div>
                    
                    <Button onClick={() => this.props.closePopup()} className="mr-2 btn-ivdp-primary k-primary" >Fechar</Button>
                  </div>
               </div>
               <div className="modal-body">
                  <div className="details entry-popup">
                   <div className="row">
                       <div className="col-md-3">
                       <label>NIF</label>
                           <div className="custome-border">
                               <p className="m-0"> {nif}</p>
                           </div>
                       </div>
                       <div className="col-md-9">
                       <label>Nome</label>
                           <div className="custome-border">
                               <p className="m-0">{nome}</p>
                           </div>
                       </div>
                   </div>
                   <div className="row">
                       <div className="col-md-8">
                       <label>Morada</label>
                           <div className="custome-border">
                               <p className="m-0"> {moradaFiscal}</p>
                           </div>
                       </div>
                       <div className="col-md-4">
                       <label>Codigo-postal</label>
                           <div className="custome-border">
                               <p className="m-0"> {codigoPostalFiscal1}-{codigoPostalFiscal2}</p>
                           </div>
                       </div>
                   </div>

                   <div className="row">
                       <div className="col-md-4">
                       <label>Distrito</label>
                           <div className="custome-border">
                               <p className="m-0">{codDis}</p>
                           </div>
                       </div>
                       <div className="col-md-4">
                       <label>Concelho</label>
                           <div className="custome-border">
                               <p className="m-0">  {codCon}</p>
                           </div>
                       </div>
                       <div className="col-md-4">
                       <label>Freguesia</label>
                           <div className="custome-border">
                               <p className="m-0">    {codFrg}</p>
                           </div>
                       </div>
                   </div>

                    {/* <div className="nif border border-primary">
                        <label>NIF</label>
                        <div>
                            {nif}
                        </div>
                    </div> */}
                    
                    {/* <div className="nome">
                        <label>Nome</label>
                        <div>
                            {nome}
                        </div>
                    </div> */}

                    {/* <div className="morada">
                        <label>Morada</label>
                            <div>
                                {moradaFiscal}
                            </div>
                    </div> */}

                    {/* <div className="codigo-postal">
                        <label>Codigo-postal</label>
                            <div>
                                {codigoPostalFiscal1}-{codigoPostalFiscal2}
                            </div>
                    </div> */}

                    {/* <div className="distrito">
                        <label>Distrito</label>
                            <div>
                                {codDis}
                            </div>
                    </div> */}

                    {/* <div className="concelho">
                        <label>Concelho</label>
                            <div>
                                {codCon}
                            </div>
                    </div> */}

                    {/* <div className="freguesia">
                        <label>Freguesia</label>
                            <div>
                                {codFrg}
                            </div>
                    </div> */}
                  </div>
                </div>
            </div>
        )
    }
}

export default EntityDetailPopUp;